import bwmodel  from '@/config/bwmodel'
import { fetchWeixinCode } from '@/api/base'
/**
 * 
 * @param {*} data  各个平台分享基础参数
 * 具体分为
 * {
 * 	title:标题
 *  desc, 描述
 *  link, 分享链接
 *  imgUrl, 图片地址
 *  callback 回调函数，
 *  qqShare: qq
 *  wxShare ： 微信
 *  ddShare： 钉钉，
 *  weiboShare: 微博
 * }
 */
const h5Share = {
  appWxId: '',
  main: function(data) {
    let shareData = {...data, title: data.title|| '市值风云', link: data.link||window.location.href, imgUrl: data.imgUrl ||'https://file.wogoo.com/app/logo/logo6.png' }
		// data = {...shareData,...data.wxShare}
		// shareWeixin(data)
		// return
		// alert(bwmodel.app)
		console.log('bwmodel.app',bwmodel.app)
  /* eslint-disable  */
		switch (bwmodel.app) {
			case 'qq': 
			  data =  { ...shareData, ...data.qqShare}
				shareQQ(data)
			break;
			case 'weixin': 
				console.log('------->');
				data = {...shareData,...data.wxShare}
			  shareWeixin(data)
			break;
			case 'dingtalk': 
			  data =  { ...shareData, ...data.ddShare}
			  shareDingtalk(data)
			break;
			default:
				return ''
		}
	}
}
// 钉钉分享参数配置
const shareDingtalk = (data) => {
	if(!window.dd){ return}
	const config = {
		type: data.type || 1,
		title: data.title,
		content:data.desc,
		url:data.link,
		image: data.imgUrl,
		onSuccess: function () { 
			data.callback&& data.callback()
		},
		onFail: function (err) { }
	} 
	window.dd.ready(function () {
			window.dd.biz.navigation.setRight({
				show: true,
				control: true,
				onSuccess: function () {
					window.dd.biz.util.share(config)
				},
			});
	})
}
const shareQQ =(data) =>{
	if(!window.mqq){ return}
	const config = {
		share_url: data.link,
		title: data.title,
		desc: data.desc,
		image_url: data.imgUrl,
	}
	window.mqq.invoke("data", "setShareInfo", config, function(){
		data.callback&& data.callback()
	})
}
const shareWeixin = (item) => {

	// if(window.wx){ return}
    // 微信分享

		if(h5Share.appWxId){

			setWxShareInfo(item)
		} else {
      fetchWeixinCode({
        url: item.link || window.location.href.split("#")[0]
      }).then((res) => {

        if (res.resultCode === '00'){
					let data = res.data
          h5Share.appWxId = data.appId
          window.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.appId, // 必填，服务号
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
						openTagList: ['wx-open-launch-app'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData','onMenuShareQZone']
          })
					setWxShareInfo(item)
        }
      }).catch(function(error) {})
		}
}
const setWxShareInfo =(item) => {
	window.wx.ready(() => {
    var config = {
      title: item.title, // 分享标题
      desc: item.desc, // 分享描述
      link: item.link|| window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
			imgUrl: (item.shareData && item.shareData.imgUrl) || item.imgUrl, // 分享图标
    }

		console.log('config',config);

    var config2 = {
      title: (item.shareData && item.shareData.title) || item.title, // 分享标题
      link: item.link || window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: (item.shareData && item.shareData.imgUrl) || item.imgUrl, // 分享图标
    }
	  window.wx.updateAppMessageShareData({...config,success: function () {
			console.log('updateAppMessageShareData');
			item.callback&& item.callback()
			},
			cancel: function () {
				console.log('updateAppMessageShareDatacancelcancel');
			}}); // 分享给朋友、QQ
		window.wx.updateTimelineShareData({...config2,success: function () {
			item.callback&& item.callback()
			},
			cancel: function () {
			}}); 
		window.wx.onMenuShareWeibo({...config, success: function () {
			item.callback&& item.callback()
			},
			cancel: function () {
			}}); // 分享到腾讯微博
	})
	window.wx.error(function(res){
		// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
		console.log(res);
		});
}
export default h5Share


// WEBPACK FOOTER //
// ./src/utils/h5Share.js